import React, { useState } from 'react';
import { DownOutlined, PieChartOutlined } from '@ant-design/icons';
import { Dropdown, Button, Checkbox, Input } from 'antd';

const CustomMultiSelectDropdown = ({
        options,
        onChange,
        label = ' Select Business Sector',
        className = '',
        children,
        suppressIcon = false,
}) => {
        const [selected, setSelected] = useState([]);
        const [searchTerm, setSearchTerm] = useState('');
        const allKeys = options.map((item) => item.key).filter((key) => key !== 'All');

        const handleCheckboxChange = (key) => {
                if (key === 'All') {
                        if (selected.includes('All')) {
                                onChange([]);
                                setSelected([]);
                        } else {
                                onChange(['All', ...allKeys]);
                                setSelected(['All', ...allKeys]);
                        }
                } else {
                        let updated = [];
                        if (selected.includes(key)) {
                                updated = selected.filter((item) => item !== key && item !== 'All');
                        } else {
                                updated = [...selected.filter((item) => item !== 'All'), key];
                        }

                        // Auto-select 'All' if all other options are selected
                        if (allKeys.every((k) => updated.includes(k))) {
                                updated = ['All', ...allKeys];
                        }

                        onChange(updated);
                        setSelected(updated);
                }
        };

        // Filter options based on search input
        const filteredOptions = options.filter((item) =>
                item.label.toLowerCase().includes(searchTerm.toLowerCase()),
        );

        const menuContent = (
                <div className="bg-white rounded-md shadow-lg p-2 max-h-64 overflow-y-auto w-64">
                        <Input
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="mb-2"
                                allowClear
                        />
                        {children}
                        {filteredOptions.length > 0 ? (
                                filteredOptions.map((item) => (
                                        <div
                                                key={item.key}
                                                className="px-2 py-1 hover:bg-gray-100 rounded cursor-pointer"
                                                onClick={(e) => e.stopPropagation()}
                                        >
                                                <Checkbox
                                                        checked={selected.includes(item.key)}
                                                        onChange={() =>
                                                                handleCheckboxChange(item.key)
                                                        }
                                                        className="w-full custom-checkbox"
                                                >
                                                        {item.label}
                                                </Checkbox>
                                        </div>
                                ))
                        ) : (
                                <div className="text-center text-gray-500 py-2">
                                        No results found
                                </div>
                        )}
                </div>
        );

        return (
                <Dropdown
                        overlay={menuContent}
                        trigger={['click']}
                        overlayClassName="custom-dropdown"
                        onOpenChange={(open) => {
                                if (!open) {
                                        setSearchTerm('');
                                }
                        }}
                >
                        <Button
                                className={`flex items-center justify-between w-64 px-4 py-4 border rounded-lg font-medium shadow-sm transition-all
    ${className}
    ${selected.length > 0 ? 'bg-blue-50 border-blue-500 text-blue-700 font-bold' : 'hover:bg-gray-100'}
  `}
                        >
                                <span className="flex items-center gap-2 text-left">
                                        {!suppressIcon && (
                                                <PieChartOutlined className="text-gray-700" />
                                        )}
                                        {label}
                                </span>
                                {selected.length > 0 &&  (
                                        <span className="ml-2 bg-blue-500 text-white text-xs font-semibold px-2 py-0.5 rounded-full">
                                                {selected.length}
                                        </span>
                                )}
                                <DownOutlined className="text-gray-700" />
                        </Button>
                </Dropdown>
        );
};

export default CustomMultiSelectDropdown;
